const infrastructureSetupCosts = {
    nocInfrastructure: { cost: 750000, description: "NOC Infrastructure" },
    monitoringToolsAndLicenses: { cost: 500000, description: "Monitoring Tools & Licenses" },
    knowledgeBaseSetup: { cost: 150000, description: "Knowledge Base Setup" },
    initialTraining: { cost: 200000, description: "Initial Training" },
    totalOneTimeCosts: 1600000
  };
  
  export default infrastructureSetupCosts;